<template>
  <dara-image
    fit="cover"
    :src="image"
    :height="size"
    :width="size"
    :style="styles"
    style="pointer-events: none !important;"
    :class="classList"
    class="p--lg el-avatar--circle" />
</template>

<script>
import bestWriter from '@/assets/images/badge-best-writer.png';
import topWriter from '@/assets/images/badge-top-writer.png';
import topReader from '@/assets/images/badge-top-reader.png';

export default {
  name: 'DaraBadge',
  props: {
    classList: String,
    size: {
      type: Number,
      default: 45,
    },
    offsetY: {
      type: [String, Number],
      default: 1,
    },
    offsetX: {
      type: [String, Number],
      default: 1,
    },
    badge: {
      type: String,
      default: '',
      validator(type) {
        return !type || ['best-writer', 'top-writer', 'top-reader', ''].includes(type);
      },
    },
  },
  computed: {
    styles() {
      return [{
        'z-index': 1,
        position: 'relative',
        top: `${this.offsetY}rem`,
        left: `${this.offsetX}rem`,
        '-webkit-transform': 'translateY(-50%) translateX(100%)',
        transform: 'translateY(-50%) translateX(100%)',
        'margin-top': '-2.8rem',
      }];
    },
    image() {
      if (this.badge === 'best-writer') return bestWriter;
      if (this.badge === 'top-writer') return topWriter;
      if (this.badge === 'top-reader') return topReader;
      return null;
    },
  },
};
</script>
